import React from 'react';

export default function DashboardPanel({
  as: Component = 'section',
  children,
  className,
  ...panelProps
}) {
  return (
    <Component className={className} {...panelProps}>
      {children}
    </Component>
  );
}
